import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  readonly lightTheme: string = 'light'

  constructor() { }

  activeTheme: string = this.lightTheme;

  private lightMode: BehaviorSubject<boolean> = new BehaviorSubject<boolean>( this.activeTheme == this.lightTheme );

  getTheme() {
    return this.activeTheme;
  }



  setTheme(theme: string): void {
    const body = document.body;
    let themeLink = document.getElementById('app-theme') as HTMLLinkElement;

    if (themeLink) {
      themeLink.href = theme + '.css';
    }
    this.activeTheme = theme;


    if (theme === 'dark') {
      body.classList.add('dark-mode');
      body.classList.remove('light-mode');
    } else {
      body.classList.add('light-mode');
      body.classList.remove('dark-mode');
    }
    this.setLightMode(this.activeTheme == this.lightTheme )
  }

  isLightMode(): Observable<boolean> {
    return this.lightMode.asObservable();
  }


  setLightMode(isDark: boolean) {
    this.lightMode.next(isDark);
  }
}
